import type { UserAccountData } from '../accounts/apiHelpers';
import { getUserAccountData } from '../accounts/apiHelpers';

export const userAccountLoader = async (): Promise<UserAccountData> =>
  getUserAccountData();
